export default "__VITE_ASSET__DE4xX9nc__"